import { render, staticRenderFns } from "./js-coverflow.vue?vue&type=template&id=7c56a34b&"
import script from "./js-coverflow.vue?vue&type=script&lang=js&"
export * from "./js-coverflow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports